module.exports = __webpack_public_path__ + "static/media/GA_Post_do-posle.c72e6775.webp";